import { getBajaRestrictions } from '../../../api/users/getBajaRestrictions';
import createApiModule from '../../createApiModule';
import { t } from '../../../i18n';

const bajaMiembroRestrictionsModule = createApiModule({
  name: 'bajaMiembroRestrictions',
  initialData: [] as string[],
  apiMethod: getBajaRestrictions,
  parse: (data) => data,
  onError: () => ({
    message: t(
      'StoreUsersMiembrosBajaMiembroRestrictionsModuleHayUnProblemaComprobandoSiSePuedeDarDeBaja',
    ),
  }),
  onSuccess: () => {},
});

export const {
  start: getMiembroBajaRestricions,
  success: getMiembroBajaRestricionsOk,
  error: getMiembroBajaRestricionsKo,
  refresh: getMiembroBajaRestricionsRefresh,
} = bajaMiembroRestrictionsModule.slice.actions;

export default bajaMiembroRestrictionsModule;
